import { render, staticRenderFns } from "./banner8.vue?vue&type=template&id=02db146f&scoped=true&"
import script from "./banner8.vue?vue&type=script&lang=js&"
export * from "./banner8.vue?vue&type=script&lang=js&"
import style0 from "./banner8.vue?vue&type=style&index=0&id=02db146f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02db146f",
  null
  
)

export default component.exports